import { LayerProps } from "../Layer";

export interface LayerSnapshot {
  zIndex: number;
  groupId: string | null;
}

export interface CanvasState {
  backgroundColor?: string;
  backgroundImagePath?: string;
  libraryItemId?: string | null;
  width: number;
  height: number;
  layers: LayerProps[];
}

export enum LayerAction {
  Add = "add",
  Remove = "remove",
  Drag = "drag",
  Scale = "scale",
  ScaleX = "scaleX",
  ScaleY = "scaleY",
  Rotate = "rotate",
  Flip = "flip",
}
